<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.type}`"
        :data-type="context.type"
    >
        <multiselect v-model="context.model"
                     v-bind="context.attributes"
                     :allow-empty="context.allowEmpty"
                     :options="context.options"
                     :placeholder="context.placeholder"
                     :preselect-first="context.preselectFirst"
                     :searchable="true"
                     label="name"
                     track-by="name"
                     :showLabels="false"
                     @select="context.rootEmit('optionSelected', $event)"></multiselect>
    </div>
</template>

<script>
export default {
    props: {
        context: {
            type: Object,
            required: true,
            options: Object,
            placeholder: String,
            allowEmpty: false,
            preselectFirst: true,
        },

    },
    data() {
        return {};
    },
    computed: {
        model() {
            return this.context.model;
        },

    },
};
</script>
